import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ReportPreviewMappingService {
  private readonly TITLE_TO_PREVIEW_MAP: Record<string, string> = {
    'carrier loss run': 'carrier-loss-run.webp',
    'design your own 2-line detail': 'dyo-2-line-detail.webp',
    'design your own 2-line summary': 'dyo-2-line-summary.webp',
    'design your own 3-line detail': 'dyo-3-line-detail.webp',
    'design your own 3-line summary': 'dyo-3-line-summary.webp',
    'design your own ad-hoc claim': 'dyo-ad-hoc-claim.webp',
    'design your own ad-hoc payment or allocation':
      'dyo-ad-hoc-payment-or-allocation.webp',
    'design your own ad-hoc reserve change': 'dyo-ad-hoc-reserve-change.webp',
    'design your own claim set comparative': 'dyo-claim-set-comparative.webp',
    'activity detail': 'activity-detail.webp',
    'check register transaction date period for allocations':
      'check-register-transaction-date-period-for-allocations.webp',
    'claim financial matrix': 'claim-financial-matrix.webp',
    'claim paid and financial': 'claim-paid-and-financial.webp',
    'claim set comparative': 'claim-set-comparative.webp',
    'comparative detail': 'comparative-detail.webp',
    'detail claim listing': 'detail-claim-listing.webp',
    'event detail': 'event-detail.webp',
    'repeaters claim listing': 'repeaters-claim-listing.webp',
    'activity summary': 'activity-summary.webp',
    'check register transaction date period for payments':
      'check-register-transaction-date-period-for-payments.webp',
    'claim paid and financial summary': 'claim-paid-and-financial.webp',
    'claim summary': 'claim-summary.webp',
    'comparative event summary': 'comparative-event-summary.webp',
    'comparative summary': 'comparative-summary.webp',
    'event summary': 'event-summary.webp',
    'frequency analysis': 'frequency-analysis.webp',
    'lag time analysis': 'lagtime-analysis.webp',
    'loss stratification': 'loss-stratification.webp',
    'payment summary': 'payment-summary.webp',
    'severity analysis': 'severity-analysis.webp',
    'user login count': 'user-login-count.webp',
    'user roles': 'user-roles.webp',
    'claim status - csr': 'claim-status-csr.webp',
    'corporate structure extract': 'corporate-structure-extract.webp',
    'user agreement and license status':
      'user-agreement-and-license-status.webp',
  };

  getPreviewImage(reportTitle: string): string {
    const key = reportTitle.toLowerCase();
    return (
      this.TITLE_TO_PREVIEW_MAP[key] ||
      `${key.replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-')}.webp`
    );
  }
}
